'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _userUtil = require('../../../../userUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NonAdminPlanCancelSection = function NonAdminPlanCancelSection(_ref) {
    var subscriptionAdminUser = _ref.subscriptionAdminUser;

    if (!subscriptionAdminUser) return null;

    var adminName = (0, _userUtil.getDisplayName)(subscriptionAdminUser);
    var adminEmail = subscriptionAdminUser.get('email');
    var adminMailTo = 'mailto:' + adminEmail;

    return _react2.default.createElement(
        'section',
        { className: 'downgrade' },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                'Your subscription admin is',
                _react2.default.createElement(
                    'strong',
                    null,
                    ' ',
                    adminName,
                    ' '
                ),
                '(',
                _react2.default.createElement(
                    'a',
                    { href: adminMailTo },
                    adminEmail
                ),
                '). Please contact them to modifiy your plan.'
            )
        )
    );
};

NonAdminPlanCancelSection.propTypes = {
    subscriptionAdminUser: _propTypes2.default.object
};

var AdminPlanCancelSection = function AdminPlanCancelSection(props) {
    return _react2.default.createElement(
        'section',
        { className: 'downgrade' },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/account/cancel' },
                    'Downgrade to the free plan'
                )
            )
        )
    );
};

var PlanCancelSection = function PlanCancelSection(_ref2) {
    var isSubscriptionAdmin = _ref2.isSubscriptionAdmin,
        props = _objectWithoutProperties(_ref2, ['isSubscriptionAdmin']);

    return isSubscriptionAdmin ? _react2.default.createElement(AdminPlanCancelSection, props) : _react2.default.createElement(NonAdminPlanCancelSection, props);
};

PlanCancelSection.propTypes = {
    isSubscriptionAdmin: _propTypes2.default.bool
};

exports.default = PlanCancelSection;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/planSections/PlanCancelSection.js
// module id = 2070
// module chunks = 0